import React, { useState, useEffect } from "react";
import style from "./VrtSession.module.sass";
import SelectButtonRelax from "./SelectButtonRelax";
import SelectButtonEducational from "./SelectButtonEducational";


function VrtSessionForm({ center, session, tipologies, labelTypology, createUrl, indexUrl, patients = [], devices = [], presetRelax, sceneryRelax, titlePreset, titleEducationalLevel, levelName, presetEducational, sceneryEducational }) {
  const [selectedTipology, setSelectedTipology] = useState(1);
  const [selectedPatient, setSelectedPatient] = useState(patients.length > 0 ? patients[0].id : "");
  const [selectedId, setSelectedId] = useState(null);
  const [selectValues, setSelectValues] = useState({});
  const [errors, setErrors] = useState({});
  const noDevicesAvailable = devices.length === 0;
  const [selectedScenario, setSelectedScenario] = useState("");

  const [selectedDevice, setSelectedDevice] = useState(devices.length > 0 ? devices[0].id : "");

  const handleDeviceChange = (e) => {
    setSelectedDevice(e.target.value);
  };
  

  useEffect(() => {
    if (!patients || patients.length === 0) {
      console.error("Errore: Nessun paziente disponibile.");
    }
  }, [patients]);

  useEffect(() => {

    if (selectValues.image_url) {
      setSelectedScenario(selectValues.image_url);
    }
  }, [selectValues]);

  const handleScenarioChange = (newValues) => {

    setSelectValues(newValues);
    setSelectedScenario(newValues.image_url);
  };


  const submitForm = async (e) => {
    e.preventDefault();
    if (noDevicesAvailable) return;
    
    const formData = {
      vrt_session_typology_id: selectedTipology,
      selected_preset_id: selectedId,
      selected_params_values: selectValues,
      patient_id: selectedPatient,
      center_id: center,
      device_id: selectedDevice,
    };

    let response = await fetch(createUrl, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ sessions: formData }),
    });

    const data = await response.json();
    if (response.ok) {
      window.location.href = data.redirectUrl;
    } else {
      setErrors(data.errors);
    }
  };


  return (
    <div className={style.container}>
      <h2 className={style.title}>Creazione sessione Vision</h2>
      <div className={style.content}>
      <div className={style.leftPanel}>
      {patients.length > 0 ? (
        <form onSubmit={submitForm}>
          <div className={style.formGroup}>
            <label>Seleziona un paziente</label>
            <select className={style.dropdown} value={selectedPatient} onChange={(e) => setSelectedPatient(e.target.value)}>
              {patients.map((patient) => (
                <option key={patient.id} value={patient.id}>{patient.identifier}</option>
              ))}
            </select>
          </div>
          <div className={style.formGroup}>
            <label>Seleziona un dispositivo</label>
            <select 
              className={style.dropdown} 
              value={selectedDevice} 
              onChange={handleDeviceChange}
            >
              <option value="">-- Seleziona un dispositivo --</option>
              {devices.map((device) => (
                <option key={device.id} value={device.id}>{device.uuid}</option>
              ))}
            </select>
          </div>
          <div className={style.formGroup}>
            <label>{labelTypology}</label>
            <div className={style.toggleGroup}>
              <button
                className={`${style.toggleButton} ${selectedTipology === 1 ? style.active : ""}`}
                onClick={(e) => {
                  e.preventDefault(); // Impedisce la submit accidentale
                  setSelectedTipology(1);
                }}
              >
                RILASSANTE
              </button>
              <button
                className={`${style.toggleButton} ${selectedTipology === 2 ? style.active : ""}`}
                onClick={(e) => {
                  e.preventDefault(); // Impedisce la submit accidentale
                  setSelectedTipology(2);
                }}
              >
                ATTRAVERSAMENTO
              </button>
            </div>
          </div>
          {selectedTipology === 1 ? (
            <SelectButtonRelax presetRelax={presetRelax} scenery={sceneryRelax} titlePreset={titlePreset} onSelect={setSelectedId} onSelectValuesChange={handleScenarioChange}  />
          ) : (
            <SelectButtonEducational levelName={levelName} scenery={sceneryEducational} titleEducationalLevel={titleEducationalLevel} presetEducational={presetEducational} onSelect={setSelectedId} onSelectValuesChange={handleScenarioChange} />
          )}
        <div className={style.buttonGroup}>
        <button className={style.cancelButton} onClick={(e) => { e.preventDefault(); window.location.href = indexUrl}}>Annulla</button>
        <button className={style.submitButton} type="submit" disabled={noDevicesAvailable} onClick={submitForm}>Avvia</button>
      </div>
      <div className={style.errors}> 
      {noDevicesAvailable && <p>Nessun dispositivo disponibile. Termina una sessione.</p>}
         </div>
        </form>
       
      ) : (
        <p>Nessun paziente disponibile. Contatta l'amministratore.</p>
      )}
              </div>
        <div className={style.rightPanel}>
        {selectedScenario && <img src={ selectedScenario} alt="Scenario Preview" className={style.preview} />}   </div>
    </div>
    </div>
  );
}


export default VrtSessionForm;
